jQuery(document).ready(function ($) {
  // Initialize lightgallery for product sheet media (separate from carousel)
  $(".product-sheet-lightgallery").each(function () {
    $(this).lightGallery({
      selector: "a",
      download: false,
      counter: false,
      thumbnail: false,
      youtubePlayerParams: {
        modestbranding: 1,
        showinfo: 0,
        rel: 0,
        controls: 1,
      },
      videoMaxWidth: "1280px",
    });
  });

  // Initialize lightgallery for accessories images
  $(".accessories-lightgallery").each(function () {
    $(this).lightGallery({
      selector: ".accessory-image-link",
      download: false,
      counter: true,
      thumbnail: true,
      animateThumb: false,
      showThumbByDefault: false,
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Tab Switching Logic - scoped per .options-block instance
  document.querySelectorAll(".options-block").forEach(function (blockEl) {
    const tabButtons = blockEl.querySelectorAll(".option-tab-button");
    const tabContents = blockEl.querySelectorAll(".option-tab-content");

    tabButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const targetId = this.getAttribute("data-tab-target");

        // Remove active class from buttons in THIS block only
        tabButtons.forEach((btn) => {
          btn.classList.remove("active");
          btn.setAttribute("aria-selected", "false");
        });

        // Add active class to clicked button
        this.classList.add("active");
        this.setAttribute("aria-selected", "true");

        // Hide all tab contents in THIS block only
        tabContents.forEach((content) => {
          content.style.display = "none";
          content.classList.remove("active");
        });

        // Show target content (search within this block)
        const targetContent = blockEl.querySelector("#" + targetId);
        if (targetContent) {
          targetContent.style.display = "block";
          targetContent.classList.add("active");
        }
      });
    });
  });

  // Modal Logic - scoped: each color item finds its own block's modal
  function openColorModal(element) {
    const blockEl = element.closest(".options-block");
    if (!blockEl) return;
    const modal = blockEl.querySelector(".options-color-modal");
    if (!modal) return;

    const colorTitle = element.getAttribute("data-color-title");
    const colorReference = element.getAttribute("data-color-reference");
    const colorDescription = element.getAttribute("data-color-description");
    const colorImg = element.getAttribute("data-color-img");
    const colorUrl = element.getAttribute("data-color-url");

    modal.querySelector(".modal-color-title").textContent = colorTitle;
    modal.querySelector(".modal-color-reference").innerHTML = colorReference;
    modal.querySelector(".modal-color-description").innerHTML =
      colorDescription;
    modal.querySelector(".modal-color-image").src = colorImg;
    modal.querySelector(".modal-color-image").alt = colorTitle;
    modal.querySelector(".modal-color-link").href = colorUrl;

    modal.style.display = "flex";
    document.body.style.overflow = "hidden";
  }

  function closeColorModal(modal) {
    if (!modal) return;
    modal.style.display = "none";
    document.body.style.overflow = "";
  }

  // Single delegated handler for all open/close interactions
  document.addEventListener("click", function (e) {
    // Close button
    const closeBtn = e.target.closest(".options-color-modal .close-modal");
    if (closeBtn) {
      closeColorModal(closeBtn.closest(".options-color-modal"));
      return;
    }

    // Backdrop click
    if (e.target.classList.contains("options-color-modal")) {
      closeColorModal(e.target);
      return;
    }

    // Open via color item wrapper
    const colorWrapper = e.target.closest(".color-item-wrapper");
    if (colorWrapper) {
      e.preventDefault();
      openColorModal(colorWrapper);
      return;
    }

    // Open via color thumbnail
    const thumbnail = e.target.closest(".color-thumbnail");
    if (thumbnail) {
      e.preventDefault();
      openColorModal(thumbnail);
      return;
    }
  });

  // ESC key closes any open color modal
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      document
        .querySelectorAll(".options-color-modal")
        .forEach(function (modal) {
          if (modal.style.display === "flex") {
            closeColorModal(modal);
          }
        });
    }
  });
});

// Products Carousel
document.addEventListener("DOMContentLoaded", function () {
  const track = document.querySelector(".products-carousel-track");
  const slides = document.querySelector(".products-carousel-slides");
  const slideElements = document.querySelectorAll(".products-carousel-slide");
  const prevBtn = document.querySelector(".products-carousel-prev");
  const nextBtn = document.querySelector(".products-carousel-next");

  if (!track || !slides || slideElements.length === 0) return;

  let currentIndex = 0;
  // Détection automatique : on divise par 2 car PHP duplique les slides
  const totalOriginalSlides = slideElements.length / 2;
  const totalSlides = slideElements.length;
  let isTransitioning = false;
  let autoplayInterval;

  function getGap() {
    const width = window.innerWidth;
    return width >= 1024 ? 20 : 12; // gap-5 (20px) lg+, gap-3 (12px) mobile
  }

  function getSlideWidthPx() {
    // On prend la largeur réelle du premier slide
    if (slideElements[0]) {
      const slideWidth = slideElements[0].offsetWidth;
      const gap = getGap();
      return slideWidth + gap;
    }
    return 0;
  }

  function updateCarousel(smooth = true) {
    const slideWidthPx = getSlideWidthPx();
    const offset = currentIndex * slideWidthPx;

    if (!smooth) {
      slides.style.transition = "none";
    } else {
      slides.style.transition = "transform 500ms cubic-bezier(0.4, 0, 0.2, 1)";
    }

    slides.style.transform = `translateX(-${offset}px)`;
  }

  function handleTransitionEnd() {
    isTransitioning = false;

    // Si on est sur un duplicate (index >= nombre de slides originaux), on revient au slide original sans animation
    if (currentIndex >= totalOriginalSlides) {
      currentIndex = currentIndex - totalOriginalSlides;
      updateCarousel(false);
    }
    // Si on est avant le premier slide (index < 0), on va au duplicate correspondant
    else if (currentIndex < 0) {
      currentIndex = currentIndex + totalOriginalSlides;
      updateCarousel(false);
    }
  }

  function moveSlide(direction) {
    if (isTransitioning) return;

    isTransitioning = true;
    currentIndex += direction;

    // Permettre temporairement d'aller au-delà des limites pour l'effet infini
    updateCarousel(true);
  }

  // Autoplay functions
  function shouldAutoplay() {
    return window.innerWidth < 1024;
  }

  function startAutoplay() {
    stopAutoplay();
    if (!shouldAutoplay() || totalSlides <= 1) return;
    autoplayInterval = setInterval(() => {
      moveSlide(1);
    }, 5000); // Change slide every 5 seconds
  }

  function stopAutoplay() {
    if (autoplayInterval) clearInterval(autoplayInterval);
    autoplayInterval = null;
  }

  // Pause autoplay on hover
  track.addEventListener("mouseenter", stopAutoplay);
  track.addEventListener("mouseleave", startAutoplay);

  // Écouter la fin de la transition
  slides.addEventListener("transitionend", handleTransitionEnd);

  // Navigation avec les boutons
  if (prevBtn) {
    prevBtn.addEventListener("click", () => {
      moveSlide(-1);
      stopAutoplay();
      startAutoplay();
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener("click", () => {
      moveSlide(1);
      stopAutoplay();
      startAutoplay();
    });
  }

  // Support du swipe sur mobile
  let touchStartX = 0;
  let touchEndX = 0;

  track.addEventListener("touchstart", (e) => {
    touchStartX = e.changedTouches[0].screenX;
  });

  track.addEventListener("touchend", (e) => {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipe();
  });

  function handleSwipe() {
    const swipeThreshold = 50;
    if (touchEndX < touchStartX - swipeThreshold) {
      moveSlide(1); // Swipe left
      stopAutoplay();
      startAutoplay();
    }
    if (touchEndX > touchStartX + swipeThreshold) {
      moveSlide(-1); // Swipe right
      stopAutoplay();
      startAutoplay();
    }
  }

  // Support du clavier
  document.addEventListener("keydown", (e) => {
    if (e.key === "ArrowLeft") {
      moveSlide(-1);
      stopAutoplay();
      startAutoplay();
    }
    if (e.key === "ArrowRight") {
      moveSlide(1);
      stopAutoplay();
      startAutoplay();
    }
  });

  // Recalculer au resize
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      isTransitioning = false;
      updateCarousel(false);
      stopAutoplay();
      startAutoplay();
    }, 150);
  });

  // Initialisation
  updateCarousel(false);
  if (shouldAutoplay() && totalSlides > 1) {
    startAutoplay();
  }
});

// Steps-cards animation (fusionné)
document.addEventListener("DOMContentLoaded", function () {
  const cards = document.querySelectorAll(".steps-cards .step-card");
  function setAllActiveMobile() {
    cards.forEach((card) => {
      card.classList.add("active");
      card.style.flexGrow = 1;
      const btn = card.querySelector(".step-btn");
      if (btn) {
        btn.style.opacity = 1;
        btn.style.pointerEvents = "auto";
      }
    });
  }
  function setInteractiveDesktop() {
    function setActive(idx) {
      cards.forEach((card, i) => {
        if (i === idx) {
          card.classList.add("active");
          card.style.flexGrow = 3;
          const btn = card.querySelector(".step-btn");
          if (btn) {
            btn.style.opacity = 1;
            btn.style.pointerEvents = "auto";
          }
        } else {
          card.classList.remove("active");
          card.style.flexGrow = 1;
          const btn = card.querySelector(".step-btn");
          if (btn) {
            btn.style.opacity = 0;
            btn.style.pointerEvents = "none";
          }
        }
      });
    }
    setActive(0);
    cards.forEach((card, idx) => {
      card.addEventListener("mouseenter", () => setActive(idx));
      card.addEventListener("focus", () => setActive(idx));
      card.addEventListener("click", () => setActive(idx));
    });
    const stepsCards = document.querySelector(".steps-cards");
    if (stepsCards) {
      stepsCards.addEventListener("mouseleave", () => setActive(0));
    }
  }

  function handleStepsCards() {
    if (window.innerWidth < 1024) {
      setAllActiveMobile();
    } else {
      setInteractiveDesktop();
    }
  }

  handleStepsCards();
  window.addEventListener("resize", handleStepsCards);
});

/**
 * Testimonials Carousel
 */

document.addEventListener("DOMContentLoaded", function () {
  const carousels = document.querySelectorAll(
    ".testimonials-carousel-container",
  );

  carousels.forEach((carouselContainer) => {
    const track = carouselContainer.querySelector(
      ".testimonials-carousel-track",
    );
    const slides = carouselContainer.querySelector(
      ".testimonials-carousel-slides",
    );
    const slideElements = carouselContainer.querySelectorAll(
      ".testimonials-carousel-slide",
    );
    const prevButton = carouselContainer.querySelector(
      ".testimonials-carousel-prev",
    );
    const nextButton = carouselContainer.querySelector(
      ".testimonials-carousel-next",
    );
    const dots = carouselContainer.querySelectorAll(".testimonial-dot");

    if (!slideElements.length) return;

    let currentSlide = 0;
    const totalSlides = slideElements.length;
    let autoplayInterval;

    // Function to go to a specific slide
    function goToSlide(index) {
      if (index < 0) {
        currentSlide = totalSlides - 1;
      } else if (index >= totalSlides) {
        currentSlide = 0;
      } else {
        currentSlide = index;
      }

      // Update slide position
      const offset = -currentSlide * 100;
      slides.style.transform = `translateX(${offset}%)`;

      // Update dots
      dots.forEach((dot, i) => {
        if (i === currentSlide) {
          dot.classList.add("active", "bg-primary");
          dot.classList.remove("bg-gray-300");
        } else {
          dot.classList.remove("active", "bg-primary");
          dot.classList.add("bg-gray-300");
        }
      });

      // Update button states
      updateButtonStates();
    }

    // Update button states (hide on first/last slide if needed)
    function updateButtonStates() {
      if (totalSlides === 1) {
        prevButton.style.display = "none";
        nextButton.style.display = "none";
      }
    }

    // Next slide
    function nextSlide() {
      goToSlide(currentSlide + 1);
      resetAutoplay();
    }

    // Previous slide
    function prevSlide() {
      goToSlide(currentSlide - 1);
      resetAutoplay();
    }

    // Autoplay
    function startAutoplay() {
      if (totalSlides <= 1) return;

      autoplayInterval = setInterval(() => {
        nextSlide();
      }, 5000); // Change every 5 seconds
    }

    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
      }
    }

    function resetAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    // Event listeners
    if (prevButton) {
      prevButton.addEventListener("click", prevSlide);
    }

    if (nextButton) {
      nextButton.addEventListener("click", nextSlide);
    }

    // Dots navigation
    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => {
        goToSlide(index);
        resetAutoplay();
      });
    });

    // Pause autoplay on hover
    carouselContainer.addEventListener("mouseenter", stopAutoplay);
    carouselContainer.addEventListener("mouseleave", startAutoplay);

    // Keyboard navigation
    document.addEventListener("keydown", (e) => {
      if (e.key === "ArrowLeft") {
        prevSlide();
      } else if (e.key === "ArrowRight") {
        nextSlide();
      }
    });

    // Touch swipe support
    let touchStartX = 0;
    let touchEndX = 0;

    track.addEventListener(
      "touchstart",
      (e) => {
        touchStartX = e.changedTouches[0].screenX;
      },
      { passive: true },
    );

    track.addEventListener(
      "touchend",
      (e) => {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      },
      { passive: true },
    );

    function handleSwipe() {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          // Swipe left - next slide
          nextSlide();
        } else {
          // Swipe right - previous slide
          prevSlide();
        }
      }
    }

    // Initialize
    goToSlide(0); // Initialiser correctement le carrousel dès le départ
    if (totalSlides > 1) {
      startAutoplay();
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Pour chaque container de carrousel achievements
  document
    .querySelectorAll(".achievements-carousel-container")
    .forEach(function (container) {
      const track = container.querySelector(".achievements-carousel-track");
      const slidesContainer = container.querySelector(
        ".achievements-carousel-slides",
      );
      const slides = container.querySelectorAll(".achievement-slide");
      // Sélectionne tous les boutons prev/next dans ce container (mobile + desktop)
      const prevBtns = container.querySelectorAll(
        ".achievements-carousel-prev",
      );
      const nextBtns = container.querySelectorAll(
        ".achievements-carousel-next",
      );

      if (!track || !slides.length) return;

      let currentIndex = 0;
      const isDesktop = () => window.innerWidth >= 1024;

      function updateCarousel() {
        const slideWidth = slides[0].offsetWidth;
        let gap = 40; // gap-5 = 1.25rem = 20px
        if (window.innerWidth < 640) {
          gap = 20; // gap plus petit sur très petit écran
        }
        let offset;
        if (isDesktop()) {
          offset = currentIndex * (slideWidth + gap) * 2;
        } else {
          // Centrage sur mobile : calculer le décalage pour centrer le slide
          const trackWidth = track.offsetWidth;
          const visibleSlideWidth = slideWidth;
          offset = currentIndex * (slideWidth + gap);
          // Centrer le slide dans le track
          offset -= (trackWidth - visibleSlideWidth) / 2;
        }
        slidesContainer.style.transform = `translateX(-${offset}px)`;
      }

      function goPrev() {
        const maxIndex = isDesktop()
          ? Math.ceil(slides.length / 2) - 1
          : slides.length - 1;
        currentIndex = currentIndex > 0 ? currentIndex - 1 : maxIndex;
        updateCarousel();
      }

      function goNext() {
        const maxIndex = isDesktop()
          ? Math.ceil(slides.length / 2) - 1
          : slides.length - 1;
        currentIndex = currentIndex < maxIndex ? currentIndex + 1 : 0;
        updateCarousel();
      }

      prevBtns.forEach((btn) => btn.addEventListener("click", goPrev));
      nextBtns.forEach((btn) => btn.addEventListener("click", goNext));

      window.addEventListener("resize", () => {
        currentIndex = 0;
        updateCarousel();
      });

      // Initialisation
      updateCarousel();
    });
});
